import { injectable } from 'inversify';
import format from 'date-fns/format';
import getUTCDate from '@/Framework/dateHelpers/getUTCDate';
import Request from '@/Framework/api/Rpc/Request';

export interface ITrackRequestHeaders {
  ssid: string,
  viewSsid: string,
  fingerprint: string,
  userAgent: string,
  viewerId: string,
}

const DATE_FORMAT_COOKIE = "EEEE, dd-MMM-yyyy HH:mm:ss 'UTC'";

@injectable()
class TrackRequest extends Request {
  static readonly RPC_METHOD = 'analytics.track';

  static headers: ITrackRequestHeaders;

  static basePayload: { [key: string]: any };

  constructor(eventName: string, payload?: Record<string, any>) {
    const finalPayload = TrackRequest.toPayload(payload);

    super(TrackRequest.RPC_METHOD, { subjectKey: eventName, ...finalPayload }, TrackRequest.headers);
  }

  static configure({
    headers,
    basePayload,
  }: {
    headers: ITrackRequestHeaders,
    basePayload: { [key: string]: any },
  }) {
    this.headers = headers;
    this.basePayload = basePayload;
  }

  static toPayload<T extends Record<string, any>>(payload: T = {} as T) {
    const occurredAt = format(getUTCDate(), DATE_FORMAT_COOKIE);

    return {
      ...TrackRequest.basePayload,
      ...payload,
      occurredAt,
    };
  }
}

export default TrackRequest;
